'use strict';

const updateStoreLink = require('../header/store').updateStoreLink;

module.exports = function () {
    // updating dataset and storename for mobile/menu storeheader icon
    // from desktop store header

    var homeStoreId = '';
    var storeName = '';
    var storeInfo = $('.sub-nav-store-info');
    var menuStoreHeader = $('#menuStoreHeader');
    var mobileStoreHeader = $('#mobileStoreHeader');

    var storeTime = '';
    if (storeInfo.length && typeof (storeInfo.data().preferredStoreId) !== 'undefined') {
        homeStoreId = storeInfo.data().preferredStoreId;
        mobileStoreHeader.attr('data-preferred-store-id', homeStoreId);
    }
    if (menuStoreHeader.length) {
        if (homeStoreId !== '') {
            menuStoreHeader.attr('data-preferred-store-id', homeStoreId);
        }
        storeName = storeInfo.find('.store-name').text();
        storeTime = storeInfo.find('.store-time').text();
        if (menuStoreHeader.find('.store-name').text !== storeName) {
            menuStoreHeader.find('.store-name').text(storeName);
            menuStoreHeader.find('.store-time').text(storeTime);

            updateStoreLink(storeName, homeStoreId);
        }
    }
    if (storeName === '') {
        mobileStoreHeader.addClass('d-none');
        if (menuStoreHeader.length) {
            menuStoreHeader.attr('data-preferred-store-id', '');
            menuStoreHeader.addClass('d-none');
        }
    }
};
